const professionHeroCards = [
  {
    id: 'web-dev',
    cards: [
      {
        id: 1,
        title: 'Create a one page website from scratch',
        subtitle: 'We can create a landing page for a new project or refresh an existing one',
        class: 'a',
      },
      {
        id: 2,
        title: 'We make up your website design',
        subtitle:
          'If you already have a website design, we will gladly prepare an adaptive layout.',
        class: 'b',
      },
      {
        id: 3,
        title: "Let's create a complex multi-page website for the project",
        subtitle: 'We are able to work on highly complex websites with deeply nested pages.',
        class: 'c',
      },
    ],
  },
  {
    id: 'data-analysis',
    cards: [
      {
        id: 1,
        title: 'We analyze pricing',
        subtitle:
          "We will analyze your data, competitors' open data, market conditions, and current trends. We will share our conclusions and recommendations regarding the pricing policy of your company.",
        class: 'a',
      },
      {
        id: 2,
        title: 'We can build a recommendation model',
        subtitle:
          'We will customize issued recommendations. We will analyze data on the behavior of your clients. You will be able to quickly understand what to offer so that they take the suggested action.',
        class: 'b',
      },
      {
        id: 3,
        title: 'We can segment your customer base',
        subtitle:
          'We will divide users into segments, select a core, segment them by interests, and give recommendations regarding the most popular content for each group to increase their retention or formulate a discount policy.',
        class: 'c',
      },
    ],
  },
  {
    id: 'data-science',
    cards: [
      {
        id: 1,
        title: 'Text recognition',
        subtitle:
          'We handle photo recognition of texts of different languages ranging from English to Arabic.',
        class: 'a',
      },
      {
        id: 2,
        title: 'Checking and improving existing algorithms',
        subtitle:
          'We test the algorithms available to your company, check them using your data or open data, and suggest hypotheses for improvement.',
        class: 'b',
      },
      {
        id: 3,
        title: 'Recognition of audio and video files',
        subtitle:
          'We can recognize files of different types, create algorithms for finding errors in them, and generating reports.',
        class: 'c',
      },
    ],
  },
];

export default professionHeroCards;
